"use strict";

var str = "razdwatrzy";

module.exports = function () {
	if (typeof str.contains !== "function") return false;
	return (str.contains("dwa") === true) && (str.contains("foo") === false);
};



// WEBPACK FOOTER //
// ./node_modules/event-emitter/node_modules/es5-ext/string/#/contains/is-implemented.js